function formatarMoeda(texto) {
    var valor = parseFloat(texto) || 0;
    var formatado = (valor).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
    return formatado;
}

export default formatarMoeda;